import { createBrowserRouter, redirect } from 'react-router-dom';
import { Backtesting } from '../features/backtesting/backtesting';
import { LiveTrading } from '../features/live-trading/live-trading';
// import { Dashboard } from "../features/dashboard/dashboard";
import { Settings } from '../features/settings/settings';
import { ApiManagement } from '../features/settings/api-management/api-management';
import { Signup } from '../features/auth/signup';
import { Login } from '../features/auth/login';
import { TemplateBuilders } from '../features/builders/template-builders';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/signup',
    element: <Signup />
  },
  {
    path: '/',
    loader: () => redirect('/live-trading')
  },
  {
    path: '/backtesting',
    element: <Backtesting />
  },
  {
    path: '/live-trading',
    element: <LiveTrading />
  },
  {
    path: '/templates',
    element: <TemplateBuilders />
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      {
        path: '',
        element: <div>general</div>
      },
      {
        path: 'notifications',
        element: <div>notifications</div>
      },
      {
        path: 'api-management',
        element: <ApiManagement />
      }
    ]
  }
]);
